import React from 'react';

import Box from '@amzn/meridian/box';
import Button from '@amzn/meridian/button';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { setJmrFilter } from 'src/store/newJmrPageSlice/newJmrPageSlice';
import { useAppDispatch, useAppSelector } from 'src/store/store';
import { JmrJobTypes } from 'src/utils/jmrUtils';

import './tldAlertModal.scss';

interface TldAlertModalProps {
  onConfirm: () => void;
  isOpen: boolean;
  setIsOpen: (val: boolean) => void;
}
const TldAlertModal = ({ onConfirm, isOpen, setIsOpen }: TldAlertModalProps) => {
  const { jmrFilter } = useAppSelector((state) => state.newJmrPage);
  const dispatch = useAppDispatch();
  const onClose = () => setIsOpen(false);

  return (
    <Modal
      title="Are you sure TLD is the best match?"
      open={isOpen}
      scrollContainer="viewport"
      closeLabel="Close"
      aria-describedby="tld-modal-description"
      width={550}
      data-cy="new-jmr__tld-modal"
    >
      <Box id="tld-modal-description" className="tld-alert-modal-body">
        <Text className="tld-alert-modal-body-first-line">
          Consider modifying a process path to address associate restrictions by adding (e.g., a stool or andon).
        </Text>
        <Text>
          I acknowledge that available process path options (with or without modification) have been reviewed and TLD
          assignment is an appropriate option for the associate.
        </Text>
      </Box>
      <ModalFooter>
        <Row alignmentHorizontal="end" widths="fit">
          <Button
            type="secondary"
            size="small"
            data-cy="tld-alert-modal__go-back"
            onClick={() => {
              dispatch(
                setJmrFilter({
                  ...jmrFilter,
                  jobType: JmrJobTypes.ProcessPath,
                }),
              );
              onClose();
            }}
          >
            Go Back
          </Button>
          <Button
            type="primary"
            size="small"
            data-cy="tld-alert-modal__keep_selection"
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            Keep Selection
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  );
};

export default TldAlertModal;
